// ============================================================================
// Component-specific configuration schemas with requirements
// ============================================================================

import { z } from "zod"

import {
  BulletedListContentSchema,
  ContentBlockSchema,
  FormattedTextContentSchema,
  TextContentJSONSchema,
} from "@tfg/types/schemas/communication-studio/components"
import {
  ContentFilteringPropsSchema,
  ProductAttributesSchema,
} from "@tfg/types/schemas/communication-studio/configurationParameters"
import { ProductSheetLanguageSchema } from "@tfg/types/schemas/languages"

export const LogoConfigurationRequiredSchema = ContentFilteringPropsSchema.pick(
  {
    logoFile: true,
  }
)

export const ProductAttributesConfigurationRequiredSchema =
  ContentFilteringPropsSchema.pick({
    primaryProductAttributes: true,
    secondaryProductAttributes: true,
  }).extend({
    primaryProductAttributes: z
      .array(ProductAttributesSchema)
      .min(1, "At least one primary product attribute is required"),
  })

export const BulletedListContentRequiredSchema = BulletedListContentSchema.omit(
  { items: true }
).extend({
  items: z.array(
    FormattedTextContentSchema.omit({ text: true }).extend({
      text: z.string().min(1, "At least one item is required"),
    })
  ),
})

export const ContentBlockRequiredSchema = ContentBlockSchema.extend({
  textContent: z
    .array(
      TextContentJSONSchema.omit({ text: true }).extend({
        text: z.string().min(1, "At least one text is required"),
      })
    )
    .or(BulletedListContentRequiredSchema)
    .or(z.array(FormattedTextContentSchema).min(1)),
})

export const ComponentContentRequiredSchema = z
  .record(ProductSheetLanguageSchema, z.array(ContentBlockRequiredSchema))
  .refine(
    (data) => Object.keys(data).length > 0,
    "At least one language with content is required"
  )
